var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class QuarterIdentifier {
  constructor(_data) {
    /**
     */
    __publicField(this, "Quarter");
    /**
     */
    __publicField(this, "Year");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof QuarterIdentifier
     */
    __publicField(this, "$type", "V1.Cesop.Periods.Search.QuarterIdentifier");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Quarter = _data["Quarter"];
      this.Year = _data["Year"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["Quarter"] = this.Quarter;
    _data["Year"] = this.Year;
    return _data;
  }
}
